import config from 'isomorphic-config'
import { useContext, useState } from 'react'

import BootstrapDataContext from '@/context/BootstrapDataContext'
import isAbortSignalTimeoutSupported from '@/shared-utils/is-abortSignal-supported'

type FormValues = {
  phoneNumber: string
}

export default function useHandleAppDownloadSubmit() {
  const {
    referral: { clickId, id, sourceId },
  } = useContext(BootstrapDataContext)
  const [signUpState, setSignUpState] = useState('NOT_SIGNED_UP')

  const query = `mutation SmsSend($request: smsSendRequest!) {
    smsSend(request: $request) {
      success
      requestId
      message
    }
  }`

  function formatPhoneNumber(phoneNumber: string) {
    return phoneNumber.replace(/[^\d]/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$2-$3-$4')
  }

  const handleSubmitNumber = async (values: FormValues) => {
    const { phoneNumber } = values
    const formattedNumber = formatPhoneNumber(phoneNumber)
    const validFormat = /^\d{3}[-]\d{3}[-]\d{4}$/.test(formattedNumber)
    if (!validFormat) {
      setSignUpState('SIGN_UP_ERROR')
      return
    }

    const { url, timeout } = config.client['pcln-graph']
    const requestUrl = `${url}?gqlOp=SmsSend`
    const variables = {
      request: {
        toPhoneNo: formattedNumber,
        function: 'SMS_CUSTOMER',
        subFunction: 'APP_DOWNLOAD',
        pageId: 'HP_TRIO',
        refId: id,
        refClickId: clickId,
        refSourceId: sourceId,
      },
    }

    try {
      setSignUpState('SIGN_UP_IN_PROGRESS')
      const response = await fetch(requestUrl, {
        method: 'POST',
        body: JSON.stringify({ query, variables }),
        headers: { 'content-type': 'application/json' },
        signal: isAbortSignalTimeoutSupported() ? AbortSignal.timeout(timeout) : undefined,
      })
      if (!response.ok) {
        setSignUpState('SIGN_UP_ERROR')
        return
      }

      const body = await response.json()
      if (body.errors || body.data?.smsSend?.success !== true) {
        setSignUpState('SIGN_UP_ERROR')
        return
      }

      setSignUpState('SIGNED_UP')
    } catch {
      setSignUpState('SIGN_UP_ERROR')
    }
  }

  return [handleSubmitNumber, signUpState]
}
